<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>
            <v-icon>mdi-clipboard-text</v-icon>Products
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <product-form />
          <product-set-form />
        </v-toolbar>
        <product-list store="products/index" :headers="headers"></product-list>
      </v-card>
    </div>
  </div>
</template>
<script>
import ProductList from "@components/products/ProductList.vue";
import ProductForm from "@components/products/ProductForm.vue";
import ProductSetForm from "@components/products/ProductSetForm.vue";

export default {
  components: {
    ProductList,
    ProductForm,
    ProductSetForm
  },
  data() {
    return {
      headers: [
        { text: "Code", value: "code", align: "left" },
        { text: "Sku", value: "sku", align: "left" },
        { text: "Name", value: "name" },
        { text: "Brand", value: "brand" },
        { text: "Classification", value: "classification" },
        { text: "Set", value: "set.name", align: "right" },
        { text: "On hand", value: "on_hand", align: "right" },
        { text: "Pending", value: "pending", align: "right" },
        { text: "Available", value: "available", align: "right" },
        { text: "Incoming", value: "incoming", align: "right" },
        { text: "Status", value: "status" },
        { text: "", value: "actions" }
      ]
    };
  }
};
</script>
